import Address from '@/models/Customers/Addresses/Address';
import Association from "@/models/Customers/Associations/Association";

export default class Person {
    id: string = '';
    externalId: string = '';
    title: string = '';
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    dateOfBirth: string = '';
    phone: string = '';
    phoneCountry: string = '';
    metadata: JSON;
    associations: Association[] = [];
    addresses: Address[] = [];
    createdAt: Date = new Date();
    updatedAt: Date  = new Date();
}